module.exports = __webpack_public_path__ + "media/audios/kid/lesson_8/audio_tpc8_guloseima-5baf1b86d43c9f43498e4a15388a50c6.m4a";